import { ExpandableSection } from "../ExpandableSection.jsx";
import { Table } from "../Table.jsx";

const Section = ({ items, classes }) =>
  items?.length > 0 && (
    <ExpandableSection title="Clicks on Call to Action (CTA)" classes={classes}>
      <Table
        classes={classes}
        columns={tableColumns}
        items={items.toSorted((a, b) => b.eventCount - a.eventCount)}
        keyField="element_name"
      />
    </ExpandableSection>
  );

const tableColumns = [
  { xs: 9, sm: 9, md: 9, label: "CTA category", field: "element_name" },
  { xs: 3, sm: 3, md: 3, label: "Clicks", field: "eventCount" },
];

export default Section;
